import React from "react";
import { Wrap, SectionHead, Note, Reveal } from "./Section";

function FeeCard({ title, rows }) {
  return (
    <div className="card rounded-2xl p-8 h-full">
      <div className="label text-[var(--muted)] mb-6">{title}</div>
      <div className="space-y-4">
        {rows.map((r, i) => (
          <div key={i} className={`flex items-center justify-between ${i < rows.length - 1 ? "border-b border-white/[0.06] pb-4" : ""}`}>
            <span className="text-[14px] text-[var(--muted)]">{r[0]}</span>
            <span className={`mono text-lg ${r[2] ? "text-accent" : r[3] ? "text-orange-400" : "text-[var(--text)]"}`}>{r[1]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function GrossToNet() {
  return (
    <Wrap>
      <SectionHead
        tag="Gross to net"
        title="What a 1% month"
        highlight="actually pays you"
        desc="One cost exists: 30% of realised profit, on a high-water-mark basis. No management fee, no subscription, no entry cost. Here is the full arithmetic on $1,000."
      />
      <div className="mt-12 grid md:grid-cols-2 gap-5">
        <Reveal direction="left" delay={1}>
          <FeeCard title="12× account — $1,000 investment" rows={[
            ["Trading volume", "$12,000"], ["1% return on volume", "$120"],
            ["Performance fee (30%)", "−$36", false, true], ["Net profit", "$84", true],
          ]} />
        </Reveal>
        <Reveal direction="right" delay={2}>
          <FeeCard title="24× account — $1,000 investment" rows={[
            ["Trading volume", "$24,000"], ["1% return on volume", "$240"],
            ["Performance fee (30%)", "−$72", false, true], ["Net profit", "$168", true],
          ]} />
        </Reveal>
      </div>
      <Reveal delay={1}>
        <div className="mt-8 card rounded-2xl p-6 max-w-3xl">
          <div className="label text-accent mb-2">High watermark, in plain terms</div>
          <p className="text-[14px] text-[var(--muted)] leading-relaxed">
            The fee applies only to new profit above the highest value your account has previously reached. If the account loses ground, the recovery back to that previous peak carries no fee — you never pay twice on the same gains.
          </p>
        </div>
      </Reveal>
      <Note>
        These are arithmetic illustrations of the fee structure at an assumed 1% monthly return on volume, not a forecast. Returns can be lower, zero, or negative.
      </Note>
    </Wrap>
  );
}
